import React from 'react'

interface ProductCatalogIconProps {
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
}

const ProductCatalogIcon: React.FC<ProductCatalogIconProps> = ({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Grid layout */}
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
      {/* Product indicators */}
      <circle cx="6.5" cy="6.5" r="1" fill={color} />
      <circle cx="17.5" cy="6.5" r="1" fill={color} />
      <circle cx="6.5" cy="17.5" r="1" fill={color} />
      <circle cx="17.5" cy="17.5" r="1" fill={color} />
    </svg>
  )
}

export default ProductCatalogIcon
